import React, { useState } from "react";
import { Link } from "../router";
import PageHero from "../components/PageHero";
import { ASSET_CLASSES } from "../data/properties";

export default function BuyPage() {
  const [sent, setSent] = useState(false);
  const [types, setTypes] = useState([]);

  const toggle = (t) => setTypes((arr) => (arr.includes(t) ? arr.filter((x) => x !== t) : [...arr, t]));

  return (
    <>
      <PageHero
        eyebrow="Buyer Portal · Intent capture"
        title="Describe it once. We'll"
        italic="find it clean."
        sub="Post your exact requirement, target budget and asset type. Our intent engine matches you to live, title-vetted inventory — and alerts you the moment something new clears."
        tone={["#0B0B0C", "#161320"]}
      />

      <section className="section">
        <div className="shell">
          <div className="grid" style={{ gridTemplateColumns: "0.85fr 1.15fr", gap: "clamp(48px,6vw,88px)", alignItems: "start" }}>
            <div className="reveal">
              <span className="eyebrow">Why post intent</span>
              <h2 className="h-lg" style={{ marginTop: 24 }}>Stop scrolling.<br />Start matching.</h2>
              <p className="muted" style={{ marginTop: 20, lineHeight: 1.9 }}>
                Instead of wading through stale listings, tell us precisely what you
                want. We only ever surface assets that are live, available, and
                Aditi-certified — so every match is real.
              </p>
              <div style={{ marginTop: 36, display: "flex", flexDirection: "column", gap: 20 }}>
                {[
                  ["Precision matching", "Budget, location, asset type and must-haves — matched, not filtered."],
                  ["Verified-only alerts", "We notify you only when a title-clean asset fits. No dead inventory."],
                  ["Financing pre-arranged", "Matched assets arrive with EMI options and bank pre-qualification ready."],
                ].map(([t, b]) => (
                  <div key={t} style={{ borderLeft: "1px solid var(--champagne)", paddingLeft: 20 }}>
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>{t}</div>
                    <div className="muted" style={{ fontSize: "0.93rem", lineHeight: 1.7 }}>{b}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="reveal card" style={{ padding: "clamp(32px,4vw,48px)" }}>
              <span className="eyebrow gold">Requirement engine</span>
              <h3 className="h-md" style={{ margin: "16px 0 32px" }}>Post your requirement</h3>

              {sent ? (
                <div className="center" style={{ padding: "40px 0" }}>
                  <span className="badge live"><span className="dot" /> Requirement captured</span>
                  <h3 className="h-md" style={{ margin: "16px 0 8px" }}>We're on it.</h3>
                  <p className="muted">You'll be alerted the moment a verified match lists. Meanwhile, browse what's live.</p>
                  <Link to="/properties" className="btn btn-ink" style={{ marginTop: 18 }}>Browse live inventory <span className="arr">→</span></Link>
                </div>
              ) : (
                <form onSubmit={(e) => { e.preventDefault(); setSent(true); }} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
                  <div className="field" style={{ gridColumn: "1 / -1" }}>
                    <label>Describe your ideal property</label>
                    <textarea required placeholder="e.g. A north-facing 4BR villa near the sea, ready to move, with a private garden…" />
                  </div>

                  <div className="field" style={{ gridColumn: "1 / -1" }}>
                    <label>Asset types (select any)</label>
                    <div className="flexrow" style={{ gap: 10 }}>
                      {ASSET_CLASSES.map((t) => (
                        <button type="button" key={t} onClick={() => toggle(t)} className={`chip ${types.includes(t) ? "active" : ""}`}>
                          {types.includes(t) ? "✓ " : ""}{t}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="field"><label>Target budget</label>
                    <select required defaultValue=""><option value="" disabled>Select…</option><option>Under ₹1 Cr</option><option>₹1–3 Cr</option><option>₹3–8 Cr</option><option>₹8–20 Cr</option><option>₹20 Cr+</option></select>
                  </div>
                  <div className="field"><label>Preferred city</label><input required placeholder="Hyderabad" /></div>
                  <div className="field"><label>Locality (optional)</label><input placeholder="Jubilee Hills" /></div>
                  <div className="field"><label>Move-in timeline</label>
                    <select defaultValue=""><option value="" disabled>Select…</option><option>Immediate</option><option>3–6 months</option><option>6–12 months</option><option>Flexible</option></select>
                  </div>
                  <div className="field"><label>Full name</label><input required placeholder="Your name" /></div>
                  <div className="field"><label>Email / phone</label><input required placeholder="you@email.com" /></div>

                  <label className="flexrow" style={{ gridColumn: "1 / -1", gap: 12, fontSize: "0.88rem", color: "var(--ink-soft)", marginTop: 4 }}>
                    <input type="checkbox" style={{ width: "auto", marginTop: 2 }} /> Also pre-check my home-loan eligibility with partner banks
                  </label>

                  <button type="submit" className="btn btn-gold" style={{ gridColumn: "1 / -1", justifyContent: "center", marginTop: 8 }}>Capture my requirement <span className="arr">→</span></button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 860px) {
          .section .grid[style*="0.85fr"] { grid-template-columns: 1fr !important; }
          .card form { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </>
  );
}
